import { Typography } from "@mui/material";
import React from "react";

export const ConfidentialityPartnersOffersInformationOptIn = () => {
  return (
    <Typography>
      <strong>Oui, j’accepte de recevoir</strong> ces communications par email et/ou SMS et{" "}
      <strong>bénéficier de ces remises et avantages</strong>
    </Typography>
  );
};
